import { Box, Image, Text } from '@chakra-ui/react';
import { AnimatePresence } from 'framer-motion';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { gradientStyle } from '@/utils/styles.utils';

import { clearCashRegister } from '../../api/postApi';
import { COMMON_WEB_PATH } from '../../constant';
import useMyBalance from '../../hook/useMyBalance';
import EndGameDetail from '../EndGameDetail/EndGameDetail';
import ClearCashConfirm from './ClearCashConfirm';
import { size } from 'lodash';
import i18next from 'i18next';

const ClearCashRegisterButton = () => {
  const { t } = useTranslation();
  const i18n = (key) => t(`common.${key}`);

  const walletCurrency = useSelector((state) => state.isWalletCurrency); //從redux store中取isWalletCurrency的值 存到wallet_currency_code變數中

  const [isProcessing, setIsProcessing] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [showEndGame, setShowEndGame] = useState(false);
  const [savedBalance, setSavedBalance] = useState(null); // 儲存棄分前的餘額
  const [checked, setChecked] = useState(false); // 是否勾選
  const [transCode, setTransCode] = useState(''); // 當使用點數轉移時，儲存轉移的回傳值，要用來轉成QRcode
  const [withdrawalNumber, setWithdrawalNumber] = useState(''); //訂單號碼

  const currentBalance = useMyBalance();
  const dispatch = useDispatch();

  useEffect(() => {
    if (showConfirm) {
      dispatch({ type: 'GET_BALANCE' });
    }
  }, [showConfirm, dispatch]);

  const handleClearCashRegister = async () => {
    if (isProcessing) return;
    setIsProcessing(true); //防止重複點擊

    try {
      await clearCashRegister({
        point_transfer: checked //是否使用點數轉移
      }).then((data) => {
        const { balance, withdrawal_number, trans_code = '' } = data || {};
        setSavedBalance(balance || 0);
        setWithdrawalNumber(withdrawal_number || ''); //存 傳來的訂單號碼

        dispatch({
          type: 'MANUAL_UPDATE_BALANCE',
          payload: {
            currency: walletCurrency,
            amount: 0
          }
        }); // 手動更新餘額到 Redux
        if (trans_code) {
          setTransCode(trans_code);
        } else {
        }
        setTimeout(() => {
          setShowConfirm(false);
          setShowEndGame(true);
          // 關閉確認視窗
        }, 0);
      });

      // 等待動畫完成

      // 2.觸發登出但不跳轉
      // dispatch({
      //   type: "USER_LOGOUT",
      //   shouldRedirect: false, // 指定不要跳轉
      // });

      // 3.顯示開始遊戲按鈕
      //setShowStartGame(true);
    } catch (error) {
      console.error('棄分失敗:', error);
    } finally {
      setIsProcessing(false);
    }
  };

  // 點擊棄分按鈕時，顯示確認彈窗
  const handleClick = () => {
    if (currentBalance == 0) return;
    setShowConfirm(true);
  };

  // 取消棄分
  const handleCancel = () => {
    setShowConfirm(false);
  };

  // 處理 EndGameDetail 關閉
  const handleEndGameClose = () => {
    setShowEndGame(false);
    setTransCode(''); // 清空transCode
    setChecked(false); // 重設point_transfer狀態
  };

  return (
    <AnimatePresence>
      {/* 確認彈窗 */}
      {showConfirm && (
        <ClearCashConfirm
          onConfirm={handleClearCashRegister}
          onCancel={handleCancel}
          isProcessing={isProcessing}
          setIsProcessing={setIsProcessing}
          setChecked={setChecked}
          checked={checked}
        />
      )}

      {showEndGame && (
        <EndGameDetail
          onClose={handleEndGameClose}
          previousBalance={savedBalance}
          transCode={transCode}
          withdrawalNumber={withdrawalNumber}
        />
      )}

      {/* 棄分按鈕 */}
      <Box
        onClick={handleClick}
        position="relative"
        cursor={isProcessing || currentBalance == 0 ? 'not-allowed' : 'pointer'}
        display="flex"
        alignItems={'center'}
        justifyContent={'center'}
        filter={currentBalance == 0 ? 'grayscale(100%)' : ''}
        opacity={currentBalance == 0 ? '0.5' : '1'}
        bgImage={`url('${COMMON_WEB_PATH}/blue-layout/header_button/${i18next.language}/header_give_up_point.png')`}
        bgPosition="center"
        bgRepeat="no-repeat"
        bgSize="100% 100%"
        height={{
          base: '60px',
          xl: '65px'
        }}
        w={'160px'}
      ></Box>
    </AnimatePresence>
  );
};

export default ClearCashRegisterButton;
